<template>
    <i class="fas fa-circle" :class="{'text-success': +score === 1,'text-danger': +score === -1, 'text-gray-300': score === null}"/>
</template>

<script>
export default {
    name: "CreditScoreIcon",
    props: ['score'],
    computed: {
        desc() {
            if (+this.score === 1) {
                return "Скоринг: одобрен"
            } else if (+this.score === -1) {
                return "Скоринг: отклонён"
            }
            return "Скоринг: не пройден"
        }
    }
}
</script>

<style scoped>

</style>
